import React from 'react'
import UserPanel from '../components/data-components/elements/UserElement/UserElement'
import { User } from '../responses/users'
import { HistoryAction, HistoryData, HistoryResources } from '../responses/history'
import { getRenderer, HistoryErrorBoundary } from '../components/pages/projects/ProjectPage/Chat/factory'

export const userRenderer = (user: User): JSX.Element => <UserPanel user={user}/>
export const historyRenderer = (resources: HistoryResources, data: HistoryData, history?: boolean) =>
    // eslint-disable-next-line react/display-name
    (action: HistoryAction, index: number): JSX.Element => {
        const Renderer = getRenderer(data, action)
        return <HistoryErrorBoundary
            key={index}
            resources={resources}
            data={data}
            action={action}
        >
            <Renderer
                resources={resources}
                data={data}
                action={action}
                history={history}
            />
        </HistoryErrorBoundary>
    }